import { Button } from "./Components/button";
import { useEffect, useState } from "react";
import { cross, cloudUploadBlack } from "helper/images";
import Dropdown from "shared/Components/dropdown";
import { globalVariables } from "helper/globalVariables";
import { SELECT_TRIALS } from "redux/features/uploadTrialSlice/SelectTrials";
import { useLazyQuery } from "@apollo/client";

export const UploadModal = (props) => {
  const { showTable, modalOpen, notCloseModal, loading, onClose } = props;
  const [showModal, setShowModal] = useState(modalOpen || false);
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState();
  const [selectTrialId, setSelectTrialId] = useState();

  const [getData, { data }] = useLazyQuery(SELECT_TRIALS);
  const resultData = data?.getAllTrialCalendar;
  const trials = resultData?.data || [];
  const handlePaginationData = (page = 1, size = 20) => {
    getData({
      variables: {
        pageNumber: page,
        pageSize: size,
        role: "Host",
        approvalStatus: "Approve",
        excludeShared: true,  // Only show trials created by this user
      },
    });
  };

  const handleChange = (selectedValue) => {
    const selectedTrial = trials.find(
      (data) => data.trial.trialName === selectedValue
    );
    setError("");
    setSelectTrialId(parseInt(selectedTrial?.id) || 2);
  };
  useEffect(() => {
    handlePaginationData();
  }, []);

  useEffect(() => {
    setShowModal(modalOpen);
  }, [modalOpen]);

  const trialsDropdown = ["1st trail", "2nd trail", "3rd trail"];
  const [error, setError] = useState("");
  const UploadBtn = () => {
    if (!file && !selectTrialId) {
      setError("File and select Trial are missing."); // Both file and id are missing
    } else if (!file) {
      setError("File is missing."); // Only file is missing
    } else if (!selectTrialId) {
      setError("select trial is missing."); // Only id is missing
    } else {
      showTable(file, selectTrialId);
    }
  };
  const handleFileChange = (event) => {
    const uploadedFile = event.target.files[0];
    if (uploadedFile) {
      setFileName(uploadedFile.name);
      setFile(uploadedFile);
    } else {
      setFileName("");
      setFile("");
    }
  };

  const openModal = () => {
    setShowModal(!showModal);
    onClose?.();
  };

  return (
    <>
      {showModal && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white w-96 pl-8 rounded-lg shadow-lg">
            <div className="flex justify-between items-center mb-4 ">
              <img
                className="mt-4 h-12 px-2 py-2 w-12 rounded-md border-1 border border-gray-200 text-gray-500"
                src={cloudUploadBlack}
                alt="upload"
              />

              <button onClick={openModal}>
                <img
                  className="h-7 w-7 text-gray-500 mr-6"
                  src={cross}
                  alt="close"
                />
              </button>
            </div>

            <div className="flex justify-between items-center">
              <span className="text-gray-900 font-inter font-semibold text-lg leading-7">
                Upload Trials Results
              </span>
            </div>
            <p className="text-gray-600 mb-4 font-inter text-base font-normal leading-5">
              Select a trial to upload results
            </p>

            <div className="flex items-center mb-2">
              <Dropdown
                // dropdownOptions={trials.map(data=>data.trial.trialName)}

                dropdownOptions={trials.map((data) => data.trial.trialName)}
                placeholder={globalVariables.selectTrialsPlaceholder}
                onChange={(selectedValue) => handleChange(selectedValue)}
                selectedOption={selectTrialId}
                width="w-[319px]"
              />
            </div>
            {error && <p className="text-red text-xs mb-2">{error}</p>}

            <div className="flex items-center mb-4">
              <div className="flex flex-col items-center justify-center">
                <label
                  style={{ width: "320px" }}
                  htmlFor="file-upload"
                  className="relative w-32 h-32 rounded-md border-1 border border-gray-300 flex items-center justify-center cursor-pointer"
                >
                  <div className="flex flex-col items-center justify-center">
                    <div>
                      <img
                        className="h-9  w-9 mt-4 rounded-md border-1 border border-gray-300 text-gray-500"
                        src={cloudUploadBlack}
                        alt="upload"
                      />
                    </div>
                    <div className="text-center text-gray-600 text-md m-4">
                      <span className="text-purple-900 font-semibold">
                        Click to upload
                      </span>{" "}
                      or drag and drop <br></br>CSV or Excel {fileName}
                    </div>
                  </div>

                  <input
                    type="file"
                    id="file-upload"
                    className="hidden"
                    accept=".csv,.xlsx"
                    onChange={handleFileChange}
                    disabled={!!props?.loading}
                  />
                </label>
                <div className="flex justify-between mt-4">
                  <Button label="Cancel" disabled={false} onClick={openModal} />
                  <div className="mx-1"></div>
                  <Button
                    label="Upload"
                    disabled={!!props?.loading}
                    className={`px-10 h-11 font-semibold text-base text-white items-center ${
                      props?.loading ? "opacity-50" : ""
                    }`}
                    onClick={UploadBtn}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
